import { v4 as uuidv4 } from 'uuid'
import { registerAction } from '../../Action'

const HANDLE_ERROR = 'HANDLE_ERROR'

const reducer = (state = {}, action) => {
  const { component } = action.payload

  const currentComponentErrors = state.errors && state.errors[component]
  let newComponentErrors = [{ ...action.payload, uuid: uuidv4() }]
  if (currentComponentErrors) {
    newComponentErrors = [
      { ...action.payload, uuid: uuidv4() },
      ...currentComponentErrors,
    ]
  }

  return {
    ...state,
    errors: {
      ...state.errors,
      [component]: newComponentErrors,
    },
  }
}

const handleError = registerAction(HANDLE_ERROR, { reducer })

export default handleError
